module.exports = __webpack_public_path__ + "static/chamaedorea-elegans-66a3db81c4a51a452af8b447a72e874a.svg";